module.exports = __webpack_public_path__ + "static/img/hwaq_fwal_msfwpt_appimg.3e26360.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hwaq_fwal_msfwpt_appimg.png
// module id = 1F6J
// module chunks = 21